var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "header-text" }, [
          _vm._v("Cancelar oferta de limpeza")
        ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "body" },
        [
          _c("Tip", [
            _vm._v(
              "\n      Não é possível editar as informações da limpeza após a oferta ter sido criada. Você pode cancelar essa oferta, editar os filtros e criar uma nova oferta.\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "button",
          {
            staticClass: "btn bg-purple",
            on: {
              click: function($event) {
                _vm.$emit("cancelOrderOffer")
              }
            }
          },
          [_c("span", [_vm._v("cancelar oferta e editar filtros")])]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn bg-outlined",
            on: {
              click: function($event) {
                _vm.$emit("closeCancelOrderOfferModal")
              }
            }
          },
          [_c("span", [_vm._v("voltar")])]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6315716e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6315716e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalOfferList/CancelOrderOffer.vue
// module id = null
// module chunks = 